import React from 'react';
import ceo from '../assets/CEO.png'

const About = () => {
  
  // Logos of tech you use (Use reliable SVG URLs or local assets)
  // These act as "Trust Badges"
  const techLogos = [
    { name: "React", url: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
    { name: "Node.js", url: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg" },
    { name: "Next.js", url: "https://assets.vercel.com/image/upload/v1662130559/nextjs/Icon_light_background.png" },
    { name: "Stripe", url: "https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg" },
    { name: "MongoDB", url: "https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg" },
    { name: "AWS", url: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" }
  ];

  return (
    <section className="bg-[#0f172a] py-24 border-t border-white/5 relative overflow-hidden">
      
      <div className="container mx-auto px-6">
        
        {/* --- PART 1: THE FOUNDER NOTE --- */}
        <div className="flex flex-col md:flex-row gap-16 items-center mb-24">
            
            {/* Image / Avatar Area */}
            <div className="w-full md:w-1/3 relative group">
                <div className="absolute inset-0 bg-[#00F0FF] rounded-2xl blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
                <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
                    {/* IMPORTANT: PUT YOUR REAL PHOTO HERE. 
                       It should be professional but look like a "Tech Founder" (e.g. black t-shirt, laptop).
                    */}
                    <img 
                        src={ceo} 
                        alt="Salman Haider" 
                        className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
                    />
                    
                    {/* Name Tag Overlay */}
                    <div className="absolute bottom-0 left-0 w-full bg-black/80 backdrop-blur-md p-4 border-t border-white/10">
                        <h3 className="text-white font-bold font-display text-lg">Salman Haider</h3>
                        <p className="text-[#00F0FF] font-mono text-xs tracking-widest uppercase">Lead Systems Architect</p>
                    </div>
                </div>
            </div>

            {/* Text Content */}
            <div className="w-full md:w-2/3">
                <span className="text-[#00F0FF] font-mono text-sm tracking-widest uppercase mb-4 block">
                    // Mission Statement
                </span>
                <h2 className="text-3xl md:text-5xl font-black text-white font-display mb-8 leading-tight">
                    "CODE IS CHEAP. <br/>
                    <span className="text-gray-500">ARCHITECTURE IS EXPENSIVE."</span>
                </h2>
                
                <div className="space-y-6 text-gray-400 text-lg leading-relaxed">
                    <p>
                        Most agencies will sell you a template and disappear. At <strong className="text-white">Top Orion</strong>, we build digital assets that define your business.
                    </p>
                    <p>
                        I founded this firm with a singular focus: to bring <strong>Silicon Valley-grade engineering</strong> to founders who are tired of broken plugins and slow dashboards.
                    </p>
                    <p>
                        When you work with us, you don't just get a developer. You get a partner who understands <strong className="text-white">Stripe economics</strong>, <strong className="text-white">user retention</strong>, and <strong className="text-white">scale</strong>.
                    </p>
                </div>

                {/* Signature / Stamp */}
                <div className="mt-12 pt-8 border-t border-white/10 flex items-center gap-6">
                    <div className="font-handwriting text-3xl text-white opacity-80" style={{ fontFamily: 'cursive' }}>
                        Salman H.
                    </div>
                    <div className="text-xs font-mono text-gray-600 uppercase tracking-widest border border-gray-700 px-2 py-1 rounded">
                        Verified Operator
                    </div>
                </div>
            </div>
        </div>


        {/* --- PART 2: THE TECH STACK TRUST BAR --- */}
        {/* This tells clients: "We use the big tools you trust" */}
        <div className="border-y border-white/5 bg-[#18181b]/30 py-10">
            <p className="text-center text-gray-600 font-mono text-xs uppercase tracking-[0.3em] mb-8">
                Powered by Industry Standard Infrastructure
            </p>
            
            <div className="flex flex-wrap justify-center gap-12 md:gap-20 items-center opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
                {techLogos.map((tech) => (
                    <img 
                        key={tech.name} 
                        src={tech.url} 
                        alt={tech.name} 
                        className="h-8 md:h-10 w-auto hover:brightness-125 transition-all"
                    />
                ))}
            </div>
        </div>

      </div>
    </section>
  );
};

export default About;